/*
 * @Author: your name
 * @Date: 2021-02-21 22:03:08
 * @LastEditTime: 2021-08-23 01:04:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /red_packet_admin/src/api/modules/user.js
 */
import request from "../request";

// 基本信息保存
export function setBaseInfo(data) {
  return request({
    url: "/user/setInfo",
    method: "post",
    data,
  });
}

// 提交信息
export function saveSubClaim(data) {
  return request({
    url: "/user/subClaim",
    method: "post",
    data,
  });
}

// 查询用户基本信息
export function getUserInfo(params) {
  return request({
    url: "/user/getInfo",
    method: "get",
    params,
  });
}

// 获取理赔信息照片信息
export function getClaimInfo(params) {
  return request({
    url: "/user/getClaimInfo",
    method: "get",
    params,
    noIntercept: true,
  });
}

// 同身份证和同保单类型 是否有未体检单据
export function hasUnSubmitUserInfo(data) {
  return request({
    url: "/user/hasUnsubmitUserInfo",
    method: "post",
    data,
    noIntercept: true,
  });
}

// 检索理赔信息
export function queryClaim(params) {
  return request({
    url: "/user/queryClaim",
    method: "get",
    params,
  });
}
// 确认金额信息
export function confirmClaimMoney(data) {
  return request({
    url: "/user/confirmClaimMoney",
    method: "post",
    data,
  });
}
